import { ORDER_HISTORY_REPORT_DETAILS_API } from 'constants/AppConstants';
import { retryAPI } from 'utils/app.utils';

export default async (reportIds, companyId, orgNodeId) => {
  try {
    const response = await retryAPI(() => fetch(
      ORDER_HISTORY_REPORT_DETAILS_API,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          reportIds,
          companyId,
          orgNodeId,
        }),
      },
    ));

    const json = await response.json();
    if (!response.ok) return { ok: false, json, status: response.status };

    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
